export default "__VITE_ASSET__CCd9I_LQ__"